RivalIQ.apps.AdsInsights.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.checkFeatureAccess = RivalIQ.apps.Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetAdsInsightsAuthTemplate',
        upsellTemplate: '#widgetAdsInsightsUpsellTemplate',
        channel: RivalIQ.enums.sources.FACEBOOK_ADS
    });

    filters.loadAdLabelsAndCustomConversions = function (curation) {
        // We need to load ad labels so can get the friendly names into export subtitles.
        // We need to load custom conversions as, if the account has any, we need to add in some custom metrics.
        const fetchAttrs = {
            adAccountId: curation.getProp('adAccountId')
        };

        return $.when(
            RivalIQ.apps.AdsInsights.data.adLabels.fetch(fetchAttrs),
            RivalIQ.apps.AdsInsights.data.customConversions.fetch(fetchAttrs)
        ).then(function (adLabels, customConversions) {
            curation.adLabels = adLabels;

            // I'm adding these custom metrics to the page global object as it needs to be there to power the table, dropdowns, and tooltips.
            // These metrics are only applicable for a given ad account, and it should not be possible to reference them outside of the
            // context of that ad account.
            const customConversionMetrics = RivalIQ.apps.AdsInsights.data.CustomConversionMetrics.buildCustomConversionMetrics(curation.getProp('adAccountId'), customConversions);
            _.extend(RivalIQ.metrics.definitions.facebookAds, customConversionMetrics);

            curation.customConversionMetrics = customConversionMetrics;
        });
    };

    filters.removeInapplicableTableMetrics = function (curation) {
        let tableMetrics = curation.getProp('tableMetrics');

        if (tableMetrics) {
            const adAccountId = curation.getProp('adAccountId');
            tableMetrics = _.filter(tableMetrics, function (metric) {
                const metricDef = RivalIQ.metrics.definitions.facebookAds[metric.property];

                // metric is applicable if it's global or if the applicable ad account is the one we're looking at in this curation instance.
                return metricDef && (
                    !metricDef.applicableAccountId || metricDef.applicableAccountId === adAccountId
                );
            });

            if (_.isEmpty(tableMetrics)) {
                // at least show something if we removed all the metrics.
                tableMetrics = [{
                    property: 'spend'
                }];
            }

            curation.setProps('tableMetrics', tableMetrics);
        }
    };

    // exposed for testing.
    filters._findDefaultAdAccountId = function (curation) {
        const landscapeId = curation.getProp('landscapeId');

        let adAccountId = _.get(RivalIQ.state.user.get('lastSelectedAdAccounts'), landscapeId);

        // make sure this ad account is still in the list of ad accounts accessible by the user.
        if (adAccountId) {
            if (!_.find(curation.facebookAdAccounts, {
                id: adAccountId
            })) {
                adAccountId = null;
            }
        }

        if (!adAccountId) {
            adAccountId = _.get(_.head(curation.facebookAdAccounts), 'id');
        }

        return adAccountId;
    };

    filters.loadFacebookAdAccounts = function (curation) {
        return RivalIQ.data.privateMetadata.fetch(_.extend({
            channel: RivalIQ.enums.channels.FACEBOOK
        }, curation.getProps()))
            .then(function (metadata) {

                // we get one instance of the ad account per token back from privateMetadata, so we need to dedup by account id.
                let allFacebookAdAccounts = _.get(metadata, 'facebookAdAccounts');
                allFacebookAdAccounts = _.uniqBy(allFacebookAdAccounts, 'id');
                const allFacebookAdAccountIds = _.map(allFacebookAdAccounts, 'id');

                // it's possible that the user has [temporarily] lost access to an ad account, if so, remove it from the list of mapped accounts.
                const mappedFacebookAdAccountIds = _.intersection(RivalIQ.state.landscape.get('activeFacebookAdAccounts'), allFacebookAdAccountIds);

                // the curation uses this list for building the switcher, it should only include accessible, mapped ad accounts.
                curation.facebookAdAccounts = _.filter(allFacebookAdAccounts, function (fbAdAccount) {
                    return _.includes(mappedFacebookAdAccountIds, fbAdAccount.id);
                });

                curation.facebookAdAccount = _.find(curation.facebookAdAccounts, {
                    id: curation.getProp('adAccountId')
                });

                if (curation.facebookAdAccount) {

                    const hasCurrentlyUnblockedToken = _.some(metadata.facebookAdAccounts, function (fbAdAccount) {
                        return fbAdAccount.id === curation.facebookAdAccount.id && !fbAdAccount.oauth_token_blocked;
                    });

                    if (!hasCurrentlyUnblockedToken) {
                        // uh-oh, this user might have access to the ad account, but all the tokens that would be
                        // able to read it are currently blocked.
                        return new (Marionette.ItemView.extend({
                            template: '#adInsightsTokensBlockedErrorTemplate'
                        }))();
                    }

                } else {

                    const adAccountId = filters._findDefaultAdAccountId(curation);

                    if (adAccountId) {
                        return curation.getPath({
                            adAccountId: adAccountId,
                            adObjectId: adAccountId,
                            exploreLevel: RivalIQ.enums.facebookAdObjectTypes.CAMPAIGN
                        });
                    } else if (_.size(allFacebookAdAccounts) && !_.size(mappedFacebookAdAccountIds)) {

                        // if ad accounts exist, but none have been selected show the select ui
                        const fbAdAccounts = new App.views.FacebookAdAccounts({
                            showFooter: true
                        });

                        fbAdAccounts.on('click:done', function () {
                            curation.reload();
                        });

                        return fbAdAccounts;

                    } else {

                        // if there are just no ad accounts, you probably need update your oauth
                        const NoInsightsView = Marionette.ItemView.extend({
                            className: 'user-action-prompt widget-insights-nothing',
                            template: '#adInsightsNoAccountsTemplate'
                        });
                        return new NoInsightsView();
                    }
                }
            });
    };

    filters.loadAdObject = function (curation) {
        return App.utils.fetchAdObject(curation.getProps())
            .then(function (adObject) {
                curation.adObject = adObject;
            });
    };

    filters.setPageTitle = function (curation) {
        curation.requestAnimationFrame(function () {
            RivalIQ.apps.Shell.execute('set:document:title', RivalIQ.strings.facebook_ads_insights_app_title);
        });
    };
});
